export default {
      id: "i-ruble-usage",
      viewBox: "0 0 12 13",
      url: __webpack_public_path__ + "img/sprite.svg#i-ruble",
      toString: function () {
        return this.url;
      }
    }